import { render } from "./CardMatrixLayoutIcon.vue?vue&type=template&id=25af8a2f&ts=true"
import script from "./CardMatrixLayoutIcon.vue?vue&type=script&lang=ts"
export * from "./CardMatrixLayoutIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__